import React from "react";
import useCountUp from "@/hooks/useCountUp";

/**
 * Drop-in span that animates a numeric value when scrolled into view.
 */
export default function AnimatedNumber({ value, className, duration }) {
    const [ref, display] = useCountUp(value, duration ? { duration } : {});
    return (
        <span ref={ref} className={className} aria-label={value}>
            {display}
        </span>
    );
}
